import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api/bwm',
  headers: { 'x-api-key': process.env.REACT_APP_API_KEY || '' },
});

export const loginUser = (username, password) =>
  api
    .post('/auth/login', { username, password, source: 'build-with-mak-page' })
    .then((r) => r.data);
